import DeviceData from './DeviceData';
import DeviceItem from './DeviceItem';

function DistillationColumnDevice(props) {
	return <DeviceItem {...props} data={DeviceData.DISTILLATION_COLUMN} />;
}

export default DistillationColumnDevice;
